import {Row} from "./Row";
import {Button} from "@mui/material";
import {LogiCtrlRule, LogiCtrlStatus} from "../../../../../api/LogiCtrl";
import {useContext, useEffect, useState} from "react";
import {useBackgroundAction} from "../../../manage/sov/UseBackgroundTask";
import {api} from "../../../../../api/API";
import {EditContext} from "../../../../../misc/scroller/EditProvider";
import {OpeningLogiCtrlStatus} from "../../../../../api/Openings";
import {useProjectId} from "../../ProjectName";
import {UserRuleInstructions} from "./UserRuleInstructions";

export function HwRulesTab(props: {
    openings: number[];
    value: OpeningLogiCtrlStatus;
    onClose: () => void;
    onReload?(): void;
    ready: boolean;
    rules: LogiCtrlRule[];
    statuses: LogiCtrlStatus[]
}) {
    const [rules, setRules] = useState<LogiCtrlRule[]>([]);

    const serverRules = props.rules;
    useEffect(() => {
        setRules(serverRules);
    }, [serverRules]);

    const projectId = useProjectId();

    const [edited, setEdited] = useState(false);

    const onRuleChange = (old: LogiCtrlRule | null, updated: LogiCtrlRule) => {
        setEdited(true);

        setRules(list => {
            if(old) {
                return list.map(r => r === old ? updated : r);
            }

            return [...list, updated];
        })
    }

    const editCtx = useContext(EditContext);

    const save = useBackgroundAction({
        callback: async (input: Parameters<typeof api.logiCtrl.upsertHwRules>[0]) => {
            return api.logiCtrl.upsertHwRules(input);
        },
        onDone: () => {
            try {
                editCtx.reload();
            } catch (e) {}

            props.onReload?.();
            props.onClose();
        }
    });

    return (
        <div style={{padding: "6px 12px 12px 12px", display: "flex", flexDirection: "column", gap: 6, maxWidth: 550}}>
            <Row
                title="Hardware"
                filter={{
                    kind: "hardware",
                }}
                error={props.value.hardwareError}
                edited={props.value.hardwareEdited}
                ready={props.ready}
                rules={rules}
                statuses={props.statuses}
                onRuleChange={onRuleChange}
                autoExpand={true}
            />
            {edited && (
                <div style={{display: "flex", justifyContent: "flex-end", gap: 6, marginTop: 4}}>
                    {save.LoadingElement}
                    <Button size="small" onClick={() => props.onClose()} disabled={save.loading} sx={{textTransform: "none", fontSize: 12}}>
                        Cancel
                    </Button>
                    <Button size="small" variant="contained" onClick={() => save.callback({
                        rules,
                        project: projectId,
                        openings: props.openings,
                    })} disabled={save.loading} sx={{textTransform: "none", fontSize: 12}}>
                        Save
                    </Button>
                </div>
            )}
            <UserRuleInstructions />
        </div>
    )
}
